import { useEffect } from "react";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";

const FAQS = [
  ["How does shipping work?", "Most accessories ship within 3–5 business days via standard carriers. Larger items (saunas, hot tubs, cold plunges) ship via freight in 2–4 weeks and qualify for white glove delivery."],
  ["What is white glove delivery?", "Our premium service: our team delivers your product to its final location, unpacks, assembles and removes all packaging. Request it on any product page or with your quote and we'll arrange the details."],
  ["Do you handle installation?", "Pre-fabricated saunas assemble in a few hours. We coordinate professional installation through white glove delivery. Hardwired electric heaters always require a licensed electrician."],
  ["What about warranties?", "All products carry full manufacturer warranties. Premium brands like Kohler back their spa shells for life. Warranty details are listed on each product page."],
  ["What is your return policy?", "Unused accessories may be returned within 30 days. Large equipment returns are handled case-by-case due to freight — contact our team and we'll make it right."],
  ["How do I get pricing?", "Because every recovery space is unique, we provide tailored quotes. Add items to your cart or open any product and click Request a Quote — share your details and our team will send personalised pricing, delivery and installation options within one business day."],
  ["Do you offer commercial pricing?", "Absolutely. Gyms, hotels and spas get volume pricing, dedicated account management and installation. Visit our Commercial Solutions page to request a quote."],
];

export default function FAQ() {
  useEffect(() => window.scrollTo(0, 0), []);
  return (
    <div className="pt-16" data-testid="faq-page">
      <div className="bg-charcoal border-b border-white/10">
        <div className="max-w-3xl mx-auto px-5 py-14">
          <p className="overline">Help Centre</p>
          <h1 className="font-serif text-4xl sm:text-5xl text-cream mt-2">Frequently Asked Questions</h1>
        </div>
      </div>
      <div className="max-w-3xl mx-auto px-5 py-12">
        <Accordion type="single" collapsible className="text-cream">
          {FAQS.map(([q, a], i) => (
            <AccordionItem key={i} value={`f${i}`} className="border-white/10">
              <AccordionTrigger data-testid={`faq-${i}`} className="text-left text-cream hover:text-gold font-medium">{q}</AccordionTrigger>
              <AccordionContent className="text-cream/70 leading-relaxed">{a}</AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    </div>
  );
}
